import { useEffect } from 'react'
import NProgress from 'nprogress'
import { Box, LinearProgress } from '@material-ui/core'
import clsx from 'clsx'
import styles from './styles.module.scss'

const LoadingScreen = ({ width = 400, className }) => {
  useEffect(() => {
    NProgress.start()

    return () => {
      NProgress.done()
    }
  }, [])

  return (
    <div className={clsx(styles.container, className)}>
      <Box width={width}>
        <LinearProgress />
      </Box>
    </div>
  )
}

export default LoadingScreen
